import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { StackBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { alignItems } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/alignItems";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { borderColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderColor";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { borderStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderStyle";
import { borderWidth } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderWidth";
import { flexDirection } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/flexDirection";
import { flexWrap } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/flexWrap";
import { gap } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/gap";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  DesignProp,
  GeneralProp,
  LayoutProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Stack",
  version: 1,
  nameI18n: "builder_ui.block_type.stack",
  category: [StackBlock],
  isHidden: true,
  props: {
    children: {
      name: "Children",
      nameI18n: "builder_ui.prop_type.children",
      category: [LayoutProp],
      prop: "children",
      type: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout", "Stack"],
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        flexDirection: {
          ...flexDirection,
          defaultValue: defaultStyles.flexDirection,
        },
        alignItems: {
          ...alignItems,
          defaultValue: defaultStyles.alignItems,
        },
        justifyContent: {
          prop: "style-attribute",
          name: "Justify Content",
          nameI18n: "builder_ui.prop_type.styles.justify_content",
          category: [DesignProp, LayoutProp],
          type: "select",
          defaultValue: defaultStyles.justifyContent,
          options: [
            {
              label: "Flex Start",
              labelI18n:
                "builder_ui.prop_type.styles.justify_content_types.flex_start",
              value: "flex-start",
            },
            {
              label: "Center",
              labelI18n:
                "builder_ui.prop_type.styles.justify_content_types.center",
              value: "center",
            },
            {
              label: "Flex End",
              labelI18n:
                "builder_ui.prop_type.styles.justify_content_types.flex_end",
              value: "flex-end",
            },
            {
              label: "Space Between",
              labelI18n:
                "builder_ui.prop_type.styles.justify_content_types.space_between",
              value: "space-between",
            },
            {
              label: "Space Around",
              labelI18n:
                "builder_ui.prop_type.styles.justify_content_types.space_around",
              value: "space-around",
            },
            {
              label: "Space Evenly",
              labelI18n:
                "builder_ui.prop_type.styles.justify_content_types.space_evenly",
              value: "space-evenly",
            },
          ],
        },
        flexWrap: {
          ...flexWrap,
          defaultValue: defaultStyles.flexWrap,
        },
        gap: {
          ...gap,
          defaultValue: defaultStyles.gap,
        },
        backgroundColor: {
          ...backgroundColor,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.backgroundColor,
        },
        borderWidth: {
          ...borderWidth,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderWidth,
        },
        borderColor: {
          ...borderColor,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderColor,
        },
        borderRadius: {
          ...borderRadius,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderRadius,
        },
        borderStyle: {
          ...borderStyle,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderStyle,
        },
        sizing: {
          ...sizing,
          category: [DesignProp, SizingProp],
          defaultValue: defaultStyles.sizing,
        },
        margin: {
          ...margin,
          category: [DesignProp, MarginsProp],
          defaultValue: defaultStyles.margin,
        },
        padding: {
          ...padding,
          category: [DesignProp, PaddingsProp],
          defaultValue: defaultStyles.padding,
        },
      },
    },
  },
};
